<template>
	<div>
		<div class="wrapper">
			<!-- 날짜 선택 --------- start -->
			<v-layout align-center class="header_search">
				<v-layout class="search_wrap">
					<v-flex md2 sm3 xs12>
						<txtField class="search_box" v-model="search_message" :txtField="search"></txtField>
					</v-flex>
					<!-- <v-layout justify-end>
						<v-btn class="search_btn" color="#ff9419" @click="messages_call()"><v-icon>mdi-magnify</v-icon>조회</v-btn>
					</v-layout> -->
				</v-layout>
			</v-layout>
			<!-- 날짜 선택 ----------- end -->

			<!-- 서브 헤더 --------- start -->
			<v-layout wrap class="mt-5" align-center>
				<v-flex>
					<v-icon color="#9D9DB7">
						<!-- mdi-magnify -->
						mdi-circle-small
					</v-icon>
					<span class="sub_header">알림톡 관리 </span>
				</v-flex>
				<v-spacer></v-spacer>
				<v-flex xs2 class="search_select_type">
					<selectBoxText :sel="surveySel" @change="changeUser" :searchFruit="searchFruit" :class="'searchSel'"></selectBoxText>
				</v-flex>
			</v-layout>
			<!-- 서브 헤더 ----------- end -->
			<v-dialog v-model="addmodal" max-width="fit-content" width="100%">
				<v-tabs :background-color="$store.state.PointColor1" dark v-model="tab" flat active-class="white--text">
					<v-tab>카카오 채널</v-tab>
					<v-tab v-show="tempList.length > 0">채널 템플릿</v-tab>
					<v-spacer></v-spacer>
					<btn :btn="closeBtn" class="mt-2" :btn_icon="'mdi-close'" @click="addmodal = false"></btn>
				</v-tabs>
				<v-tabs-items v-model="tab">
					<v-tab-item>
						<v-card class="pa-2">
							<v-layout>
								<v-flex xs12>
									<v-card class="mx-auto" max-width="500" tile>
										<v-list flat>
											<v-subheader>카카오톡 채널 리스트</v-subheader>
											<v-list-item-group v-model="selectedItem" color="primary">
												<v-list-item v-for="(list, i) in frinedList" :key="i" three-line @click="listClick(list)">
													<v-list-item-content>
														<v-list-item-title>{{ list.name }} - {{ list.uuid }} </v-list-item-title>
														<v-list-item-subtitle>{{ list.senderKey }}</v-list-item-subtitle>
														<v-list-item-subtitle>생성일: {{ list.cdate }} / 수정일: {{ list.udate }}</v-list-item-subtitle>
													</v-list-item-content>
												</v-list-item>
											</v-list-item-group>
										</v-list>
									</v-card>
								</v-flex>
							</v-layout>
						</v-card>
					</v-tab-item>
					<v-tab-item class="px-4">
						<div class="wrapper" style="height:80vh; overflow:auto;">
							<v-layout class="mt-5">
								<v-flex xs2>
									<btn class="px-2" btn_txt="알림톡 전체 생성" :btn="allBtn" @click="allAdd"></btn>
									<v-spacer />
								</v-flex>
								<v-spacer />
								<v-flex xs2>
									<txtField v-model="searchTxt" :txtField="searchTxtField" />
								</v-flex>
							</v-layout>
							<datatable :datatable="kakaoChannelDatatable" :search="searchTxt" :clickEditBtn="kakaoCreate" :previewClick="previewClick2">
							</datatable>
						</div>
					</v-tab-item>
				</v-tabs-items>
			</v-dialog>
			<v-dialog v-model="updateDialog" max-width="320px" background-color="white" persistent>
				<v-container style="height: 320px; background-color: white;">
					<v-row class="fill-height" align-content="center" justify="center">
						<v-col class="text-subtitle-1 text-center" cols="12">
							카카오톡 알림톡을 <br />
							실시간 업데이트 중입니다.
						</v-col>
						<v-col cols="6">
							<v-progress-linear :color="$store.state.PointColor1" indeterminate rounded height="6"></v-progress-linear>
						</v-col>
					</v-row>
				</v-container>
			</v-dialog>
			<!-- --- 데이터 테이블 -------- start -->
			<v-layout wrap>
				<!-- 테이블 -->
				<v-flex xs12>
					<datatable
						:search="search_message"
						:datatable="table.datatable"
						class="tbl-type01"
						:detailClick="detailClick"
						:previewClick="previewClick"
						:deleteClick="deleteMessage"
					>
					</datatable>

					<div class="datatable_btn">
						<btn
							:btn="addBtn"
							:class="'small_action_btn mr-4'"
							:style="`background-color:${$store.state.PointColor2}`"
							:btn_txt="'알림톡 가져오기'"
							@click="clickAddBtn()"
						></btn>

						<v-btn dark class="small_action_btn mr-2" :style="`background-color:${$store.state.PointColor2};`" @click="clickEditBtnAll()">
							<v-icon> mdi-update </v-icon>일괄 업데이트
						</v-btn>
					</div>
				</v-flex>
			</v-layout>
		</div>

		<!-- 알림톡 가져오기 alert  -->
		<editTalkDialog :setdialog="edit_dialog" :validation_chceck="validation_chceck" />
		<!-- 알림톡 자세히 보기 alert -->
		<editTalkDetailDialog
			:setdialog="detail_dialog"
			:userSelectBox="userSelectBox"
			:userArr="userArr"
			:userClose="userClose"
			:userPick="userPick"
			:updateMessage="editUpdateMessage"
			:validation_chceck="validation_chceck"
		/>
		<!-- 미리보기 팝업  -->
		<previewTalk :setdialog="preview_dialog" />

		<!-- sweetAlet - ${}를 입력해주세요, 완료 팝업 -->
		<sweetAlert :dialog="sweetInfo" />
		<sweetAlert :dialog="sweetDelete" @click="deleteAlert()" />
	</div>
</template>

<script>
import {
	btn,
	datatable,
	txtField,
	editTalkDialog,
	sweetAlert,
	previewTalk,
	editTalkDetailDialog,
	selectBoxText,
} from '@/components/index.js'
export default {
	components: {
		btn,
		datatable,
		txtField,
		editTalkDialog,
		sweetAlert,
		previewTalk,
		editTalkDetailDialog,
		selectBoxText,
	},
	data() {
		return {
			userSelectBox: {
				value: '',
				errorMessage: '',
				hideDetail: true,
				items: [],
				fullItem: [],
				outlined: true,
				label: '',
				class: 'small_font bizInput',
				returnObject: true,
				itemText: 'username',
				itemValue: 'id',
				// filter: true,
			},
			userArr: [],
			originSelData: [],
			surveySel: {
				value: '',
				errorMessage: '',
				hideDetail: true,
				items: [],
				fullItem: [],
				outlined: true,
				label: '',
				returnObject: true,
				itemText: 'username',
				itemValue: 'id',
				filter: true,
			},
			tab: 0,
			selectedItem: null,
			datatable: {
				headers: [
					{ text: '알림톡 이름', value: 'tplCodeStr' },
					{ text: 'TPL Code', value: 'tplCode' },
					{ text: '채널아이디', value: 'plusid' },
					{ text: '사업지 코드', value: 'groupcode' },
					{ text: '발신번호', value: 'smssender' },
					{ text: '비고', align: 'center', value: 'kakakoAction2' },
				],
				items: [],
				hidedefaultfooter: false,
				noweditting: '',
			},
			kakaoChannelDatatable: {
				headers: [
					{ text: '템플릿 이름', value: 'templtName' },
					{ text: 'TPL Code', value: 'templtCode' },
					{ text: '템플릿 내용', value: 'templtContent' },
					{ text: '액션', align: 'center', value: 'kakakoAction' },
				],
				items: [],
				hidedefaultfooter: false,
				noweditting: '',
			},
			searchTxt: '',
			searchTxtField: {
				maxlength: 20,
				clearable: true,
				prependinnericon: 'mdi-magnify',
				label: 'Search',
				backCol: '#FFFFFF',
				outlined: true,
			},
			updateDialog: false,
			frinedList: [],
			messageItem: [], // 알림톡 데이터 테이블 items
			addmodal: false,
			dateChice: true,
			datedisable: true,
			// --- 데이터 테이블 데이터 --``
			table: {
				datatable: {
					class: 'datatablehover3',
					headers: [],
					items: [],
					hidedefaultfooter: false,
					noweditting: '',
					// title: x.name,
					onlyAgree: false,
					// inputboxId: x.id,
				},
				filter: [],
				json_fields: {},
			},

			reserveUsersInfo: {
				dialog: false,
				reserveList: [],
				datatable: {
					class: 'datatablehover3',
					headers: [],
					items: [],
				},
				name: '',
				phone: '',
				json_fields: {},
			},

			// 날짜/검색 데이터
			searchsel: { value: '오늘', errorMessage: '', hideDetail: true, items: ['오늘', '이번 주', '이번 달'], outlined: true },
			searchsel_type: { value: '캠페인명', errorMessage: '', hideDetail: true, items: ['캠페인명'], outlined: true },
			search_message: '',
			search: {
				placeholder: '검색어를 입력하세요.',
				maxlength: '255',
				outlined: true,
				backCol: 'white',
			},
			closeBtn: {
				iconMdi: true,
				icon: true,
				iconColor: 'white',
			},
			allBtn: {
				width: 120,
				dark: true,
				class: 'bold',
			},
			termStartpicker: {
				// datePicker
				date: this.$moment().format('YYYY-MM-DD'),
				errorMessage: '',
				class: 'whiteBack defalut-date-picker-setting',
				menu: false,
			},

			termEndpicker: {
				// datePicker
				date: this.$moment().format('YYYY-MM-DD'),
				errorMessage: '',
				class: 'whiteBack defalut-date-picker-setting',
				menu: false,
			},

			preview_dialog: {
				// 미리포기 다이어로그
				dialog: false,
				title: '철산자이 더 헤리티지',
				content: `[철산자이 더 헤리티지]

[홍길동]고객님,
[2023-01-17 14:25]에
[철산자이 더 헤리티지 고객 설문조사 이벤트]에
참여 하셨습니다.

고객님의 소중한 의견과 참여에 감사드립니다.
아래 버튼을 클릭하시면 이벤트에 관한
자세세한 내용과 분양정보를 확인 하실 수
있습니다.`,
				buttons: [
					{
						text: '카카오톡 채널 친구추가',
					},
					{
						text: '홍페이지 바로가기',
					},
					{
						text: '분양 정보 보기',
					},
					{
						text: '챗봇 바로가기',
					},
				],
			},
			edit_dialog: {
				// 알림톡 불러오기 다이어로그
				dialog: false,
				type: 'edit',
				edit_item: {},

				datatable: {
					class: 'datatablehover3',
					// 알림톡 불러오기 다이어로그 데이터테이블
					headers: [
						{ text: '템플릿 명', value: 'title' },
						{ text: '템플릿 코드', value: 'code' },
						{ text: '승인일', value: 'update_at' },
						{ text: '비고', value: 'use', align: 'center' },
					],
					items: [],
					height: '600px',
					hidedefaultfooter: false,
					showselect: true,
				},
				preview: {
					title: '철산자이 더 헤리티지',
					content: `[철산자이 더 헤리티지]

[홍길동]고객님,
[2023-01-17 14:25]에
[철산자이 더 헤리티지 고객 설문조사 이벤트]에
참여 하셨습니다.

고객님의 소중한 의견과 참여에 감사드립니다.
아래 버튼을 클릭하시면 이벤트에 관한
자세세한 내용과 분양정보를 확인 하실 수
있습니다.`,
					buttons: [
						{
							text: '카카오톡 채널 친구추가',
						},
						{
							text: '홍페이지 바로가기',
						},
						{
							text: '분양 정보 보기',
						},
						{
							text: '챗봇 바로가기',
						},
					],
				},
			},

			detail_dialog: {
				// 알림톡 자세히 보기 다이어로그
				dialog: false,
				type: 'detail',
				left_items: [
					// 0
					{
						title: '템플릿 정보',
						id: 'title',
						type: 'txtfield',
						value: '',
						txtfield: {
							maxlength: '255',
							outlined: true,
							hideDetail: true,
							errorMessage: '',
							autocomplete: 'off',
							placeholder: '',
							readonly: true,
						},
						required: true,
					},
					// 1
					{
						title: '템플릿 코드',
						id: 'code',
						type: 'txtfield',
						value: '',
						txtfield: {
							maxlength: '255',
							outlined: true,
							hideDetail: true,
							errorMessage: '',
							autocomplete: 'off',
							placeholder: '',
							readonly: true,
						},
						required: true,
					},
					// 2
					{
						title: '승인일',
						id: 'approve_date',
						type: 'txtfield',
						value: '',
						txtfield: {
							maxlength: '255',
							outlined: true,
							hideDetail: true,
							errorMessage: '',
							autocomplete: 'off',
							placeholder: '',
							readonly: true,
						},
						required: true,
					},
					// 3
					{
						title: '적용일',
						id: 'apply_date',
						type: 'txtfield',
						value: '',
						txtfield: {
							maxlength: '255',
							outlined: true,
							hideDetail: true,
							errorMessage: '',
							autocomplete: 'off',
							placeholder: '',
							readonly: true,
						},
						required: true,
					},
					// 4
					{
						title: '내용',
						id: 'preview',
						type: 'preview',
						preview: {
							title: '철산자이 더 헤리티지',
							content: `[철산자이 더 헤리티지]

[홍길동]고객님,
[2023-01-17 14:25]에
[철산자이 더 헤리티지 고객 설문조사 이벤트]에
참여 하셨습니다.

고객님의 소중한 의견과 참여에 감사드립니다.
아래 버튼을 클릭하시면 이벤트에 관한
자세세한 내용과 분양정보를 확인 하실 수
있습니다.`,
							buttons: [
								{
									text: '카카오톡 채널 친구추가',
								},
								{
									text: '홍페이지 바로가기',
								},
								{
									text: '분양 정보 보기',
								},
								{
									text: '챗봇 바로가기',
								},
							],
						},
						required: true,
					},
					// 5
					{
						title: '버튼정보',
						id: 'buttons',
						type: 'buttons',
						buttons: [
							{
								text: '카카오톡 채널 친구추가',
								value: `MO:https://pf.kakao.com/_IgBkj/friend
								PC: https://pf.kakao.com/_IgBkj/friend`,
							},
							{
								text: '홍페이지 바로가기',
								value: `MO:https://pf.kakao.com/_IgBkj/friend
								PC: https://pf.kakao.com/_IgBkj/friend`,
							},
							{
								text: '분양 정보 보기',
								value: `MO:https://pf.kakao.com/_IgBkj/friend
								PC: https://pf.kakao.com/_IgBkj/friend`,
							},
							{
								text: '챗봇 바로가기',
								value: `MO:https://pf.kakao.com/_IgBkj/friend
								PC: https://pf.kakao.com/_IgBkj/friend`,
							},
						],
						required: true,
					},
				],
				items: [
					//0
					{
						title: '내용',
						id: 'title',
						type: 'sub_message',
						value: `[철산자이 더 헤리티지]

[홍길동]고객님,
[2023-01-17 14:25]에
[철산자이 더 헤리티지 고객 설문조사 이벤트]에
참여 하셨습니다.

고객님의 소중한 의견과 참여에 감사드립니다.
아래 버튼을 클릭하시면 이벤트에 관한
자세세한 내용과 분양정보를 확인 하실 수
있습니다.`,
					},
				],
			},
			sweetInfo: {
				//  업데이트 완료
				open: false,
				title: '업데이트 완료',
				content: `알림톡 업데이트가
완료되었습니다.`,
				modalIcon: 'success',
				cancelBtnText: '확인',
				buttonType: 'oneBtn',
			},
			sweetDialog: {
				// 저장 확인 팝업
				open: false,
				title: '알림톡 가져오기',
				content: `선택하신 알림톡을
가져옵니다.`,
				cancelBtnText: '취소',
				buttonType: 'twoBtn',
				saveBtnText: '저장',
				modalIcon: 'success',
			},
			sweetDelete: {
				// 저장 확인 팝업
				open: false,
				title: '알림톡 가져오기',
				content: `선택하신 알림톡을
삭제합니다.`,
				cancelBtnText: '취소',
				buttonType: 'twoBtn',
				saveBtnText: '확인',
				modalIcon: 'warning',
				data: {},
			},
			tempList: [],
			addBtn: {
				// 추가 버튼
				dark: true,
			},
		}
	},
	async created() {
		this.$store.state.loading = true
		await this.first_messages_call()
		await this.first_users_call()
		this.$store.state.loading = false
	},
	computed: {},
	methods: {
		async deleteAlert() {
			let defaultArr = ['TN_9540', 'TN_9542', 'TN_2658', 'TN_9539']
			this.sweetDelete.open = false
			if (defaultArr.filter(x => x === this.sweetDelete.data.tplCode).length === 0) {
				this.$store.state.loading = true
				if (this.surveySel.value.id) {
					if (this.sweetDelete.data.users_permissions_users.length < 2) {
						const data = {
							id: this.sweetDelete.data.id,
						}
						await this.$store
							.dispatch('deleteMessage', data)
							.then(async () => {
								await this.first_messages_call()
							})
							.catch(() => {})
					} else {
						let idx = this.sweetDelete.data.users_permissions_users.findIndex(x => x.id === this.surveySel.value.id)
						this.sweetDelete.data.users_permissions_users.splice(idx, 1)
						const data = {
							id: this.sweetDelete.data.id,
							userID: this.sweetDelete.data.users_permissions_users.map(x => x.id),
						}
						await this.$store
							.dispatch('updateMessage', data)
							.then(async () => {
								// this.addmodal = false
								// this.messages_call()
								await this.first_messages_call()
								await this.first_users_call()
								// this.updateDialog = false
							})
							.catch(() => {
								this.updateDialog = false
								alert('업데이트 도중 오류가 발생하였습니다.')
							})
					}
				} else {
					const data = {
						id: this.sweetDelete.data.id,
					}
					await this.$store
						.dispatch('deleteMessage', data)
						.then(async () => {
							await this.first_messages_call()
						})
						.catch(() => {})
				}
				this.$store.state.loading = false
			} else {
				alert('삭제 불가능한 알림톡입니다.')
			}
		},
		userClose(val) {
			let idx = this.userArr.findIndex(x => x.id === val.id)
			this.userArr.splice(idx, 1)
			this.userSelectBox.items.push(this.originSelData.filter(x => x.id === val.id)[0])
			this.userSelectBox.value = ''
		},
		userPick(val) {
			let idx = this.userSelectBox.items.findIndex(x => x.id === val.id)
			this.userSelectBox.items.splice(idx, 1)
			this.userArr.push(this.originSelData.filter(x => x.id === val.id)[0])
		},
		async first_users_call() {
			this.$store
				.dispatch('Users', {})
				.then(res => {
					let user_data = res.data.users
					this.originSelData = JSON.parse(JSON.stringify(res.data.users))
					this.userSelectBox.items = JSON.parse(JSON.stringify(res.data.users))
					this.surveySel.items = user_data
					this.surveySel.items.unshift({ username: '전체' })
					this.surveySel.value = this.surveySel.items[0]
				})
				.catch(err => {
					console.log({ err })
				})
		},
		searchFruit(val) {
			if (val === '') {
				this.surveySel.items = this.originSelData
			} else {
				this.surveySel.items = this.originSelData.filter(x => x.username.includes(val))
			}
		},
		async changeUser() {
			this.$store.state.loading = true
			await this.messages_call()
			this.$store.state.loading = false
		},
		createMessageAll(data) {
			const datas = {
				tplCode: data.templtCode,
				tplCodeStr: data.templtName,
				plusid: this.plusid,
				senderkey: data.senderKey,
				smssender: '02-6012-0117',
				message: data.templtContent,
				isuse: 0,
			}
			if (data.buttons.length > 0) {
				datas.button = JSON.stringify({ button: data.buttons })
			}
			const dupleChekc = this.datatable.items.map(x => x.tplCode).indexOf(data.templtCode)
			if (dupleChekc > -1) {
				return
			}
			this.$store
				.dispatch('createMessage', datas)
				.then(() => {
					this.first_messages_call()
					this.addmodal = false
				})
				.catch(() => {
					this.addmodal = false
					alert('생성 도중 오류가 발생하였습니다.')
				})
		},
		clickEditBtnAll() {
			this.updateDialog = true
			this.table.datatable.items.forEach(element => {
				this.templateListCallUpdateAll(element.senderkey, element.tplCode, element.id)
			})
		},
		clickAddBtn() {
			this.tab = 0
			this.tempList = []
			this.friendListCall()
			this.addmodal = true
		},
		allAdd() {
			this.kakaoChannelDatatable.items.forEach((el, index) => {
				const indexTable = this.table.datatable.items.map(x => x.tplCode).indexOf(el.templtCode)
				if (indexTable > -1) this.updateMessage(el, this.table.datatable.items[indexTable].id)
				else this.createMessageAll(el)
				if (index === this.kakaoChannelDatatable.items.length - 1) this.first_messages_call()
			})
		},
		kakaoCreate() {
			this.create_Messages_call()
			// const indexTable = this.table.datatable.items.map(x => x.tplCode).indexOf(this.$store.state.datatableItem.templtCode)
			// if (indexTable > -1) this.updateMessage(this.$store.state.datatableItem, this.table.datatable.items[indexTable].id)
			// else this.createMessage(this.$store.state.datatableItem)
		},
		createMessage(data) {
			const datas = {
				tplCode: data.templtCode,
				tplCodeStr: data.templtName,
				plusid: this.plusid,
				senderkey: data.senderKey,
				smssender: '02-6012-0117',
				message: data.templtContent,
				isuse: 0,
				userID: this.surveySel.value.id,
			}
			if (data.buttons.length > 0) {
				datas.button = JSON.stringify({ button: data.buttons })
			}
			const dupleChekc = this.datatable.items.map(x => x.tplCode).indexOf(data.templtCode)
			if (dupleChekc > -1) {
				return alert('이미 존재하는 알림톡 입니다.')
			}
			this.$store
				.dispatch('createMessage', datas)
				.then(() => {
					this.addmodal = false
					this.messages_call()
					// this.first_messages_call()
				})
				.catch(() => {
					this.addmodal = false
					alert('생성 도중 오류가 발생하였습니다.')
				})
		},
		listClick(val) {
			this.plusid = val.uuid
			this.templateListCall(val.senderKey)
		},
		friendListCall() {
			this.$store
				.dispatch('friendListCall')
				.then(res => {
					this.frinedList = res.data.friendListCall.count
				})
				.catch(err => {
					console.log({ err })
				})
		},
		templateListCall(senderkey) {
			this.$store.state.loading = true
			const data = {
				senderkey: senderkey,
			}
			this.$store
				.dispatch('templateListCall', data)
				.then(res => {
					this.tempList = res.data.templateListCall.count
					this.tab = 1
					this.kakaoChannelDatatable.items = res.data.templateListCall.count
					this.$store.state.loading = false
				})
				.catch(err => {
					this.$store.state.loading = false
					console.log({ err })
				})
		},
		updateMessage(data, id, arr) {
			const datas = {
				id: id,
				tplCode: data.templtCode,
				tplCodeStr: data.templtName,
				senderkey: data.senderKey,
				smssender: '02-6012-0117',
				message: data.templtContent,
			}
			if (arr) {
				let userArr = arr.users_permissions_users.map(x => x.id)
				userArr.push(this.surveySel.value.id)
				datas.userID = userArr
			}
			if (data.buttons) {
				if (data.buttons.length > 0) {
					datas.button = JSON.stringify({ button: data.buttons })
				}
			}
			this.$store
				.dispatch('updateMessage', datas)
				.then(() => {
					this.addmodal = false
					this.messages_call()
					// this.first_messages_call()
					this.updateDialog = false
				})
				.catch(() => {
					this.updateDialog = false
					alert('업데이트 도중 오류가 발생하였습니다.')
				})
		},
		editUpdateMessage(id) {
			this.$store.state.loading = true
			const datas = {
				id: id,
			}
			datas.userID = this.userArr.map(x => x.id)
			this.$store
				.dispatch('updateMessage', datas)
				.then(() => {
					this.messages_call()
					// this.first_messages_call()
					alert('적용이 완료되었습니다.')
					this.$store.state.loading = false
					this.updateDialog = false
				})
				.catch(() => {
					this.$store.state.loading = false
					this.updateDialog = false
					alert('업데이트 도중 오류가 발생하였습니다.')
				})
		},
		templateListCallUpdateAll(senderkey, tplCode, id) {
			const data = {
				senderkey: senderkey,
			}
			this.$store
				.dispatch('templateListCall', data)
				.then(res => {
					res.data.templateListCall.count.forEach(element => {
						if (element.templtCode === tplCode) {
							this.updateMessage(element, id)
						}
					})
				})
				.catch(err => {
					this.$store.state.loading = false
					console.log({ err })
				})
		},
		templateListCallUpdate(senderkey, tplCode) {
			const data = {
				senderkey: senderkey,
			}
			this.$store
				.dispatch('templateListCall', data)
				.then(res => {
					res.data.templateListCall.count.forEach(element => {
						if (element.templtCode === tplCode) {
							this.updateMessage(element)
						}
					})
				})
				.catch(err => {
					this.$store.state.loading = false
					console.log({ err })
				})
		},
		async deleteMessage(item) {
			// console.log(item)
			this.sweetDelete.data = item
			this.sweetDelete.open = true
		},
		async first_messages_call() {
			// 약관 내역 호출
			let variable = {}
			await this.$store
				.dispatch('messages', variable)
				.then(res => {
					let messages_data = res.data.messages
					this.set_table_data(messages_data)
				})
				.catch(err => {
					console.log(err)
				})
		},
		async messages_call() {
			// 약관 내역 호출

			let variable = {
				tplCodeStr: this.search_message,
				userID: this.surveySel.value.id,
			}
			this.$store
				.dispatch('messages', variable)
				.then(res => {
					let messages_data = res.data.messages
					this.set_table_data(messages_data)
				})
				.catch(err => {
					console.log(err)
				})
		},
		async create_Messages_call() {
			// 약관 내역 호출
			let variable = {}
			this.$store
				.dispatch('messages', variable)
				.then(res => {
					let idx = res.data.messages.findIndex(x => x.tplCode === this.$store.state.datatableItem.templtCode)
					if (idx === -1) {
						this.createMessage(this.$store.state.datatableItem)
					} else {
						this.updateMessage(this.$store.state.datatableItem, res.data.messages[idx].id, res.data.messages[idx])
					}
				})
				.catch(err => {
					console.log(err)
				})
		},

		set_table_data(term_data) {
			let headers = [
				{ text: '템플릿 명', value: 'tplCodeStr' },
				{ text: '템플릿 코드', value: 'tplCode' },
				{ text: '승인일', value: 'created_at' },
				{ text: '적용일', value: 'created_at' },
				{ text: '비고', align: 'center', value: 'etc_detail_preview_kakao' },
			]
			let tableItems = {
				datatable: {
					class: 'datatablehover3',
					headers: headers,
					items: term_data,
					// hidedefaultfooter: false,
					noweditting: '',
					title: '테스트 타이틀',
					onlyAgree: false,
					// inputboxId: x.id,
				},
				// json_fields: exportField,
			}
			this.table = tableItems
		},

		detailClick(item) {
			this.userSelectBox.items = JSON.parse(JSON.stringify(this.originSelData))
			let preview_buttons = item.button ? JSON.parse(item.button) : []
			if (preview_buttons) {
				if (preview_buttons.button) {
					preview_buttons = preview_buttons.button
				}
			} else {
				preview_buttons = []
			}
			this.userArr = []

			preview_buttons.forEach(el => {
				el['text'] = el.name
				let new_text = `MO : ${el.linkMo} \n PC : ${el.linkPc}`
				el.value = new_text
			})

			this.detail_dialog.left_items[0].value = item.tplCodeStr
			this.detail_dialog.left_items[1].value = item.tplCode
			this.detail_dialog.left_items[2].value = this.$moment(item.created_at).format('YYYY-MM-DD')
			this.detail_dialog.left_items[3].value = this.$moment(item.created_at).format('YYYY-MM-DD')
			this.detail_dialog.left_items[4].preview.title = item.tplCodeStr
			this.detail_dialog.left_items[4].preview.content = item.message
			this.detail_dialog.left_items[4].preview.buttons = preview_buttons
			this.detail_dialog.left_items[5].buttons = preview_buttons

			this.detail_dialog.items[0].value = item.message
			this.detail_dialog.item = item

			this.detail_dialog.dialog = true
		},
		previewClick2(item) {
			let preview_buttons = item.buttons ? item.buttons : []
			if (preview_buttons) {
				if (preview_buttons.button) {
					preview_buttons = preview_buttons.button
				}
			} else {
				preview_buttons = []
			}

			preview_buttons.forEach(el => {
				el['text'] = el.name
			})

			this.preview_dialog.title = item.templtName
			this.preview_dialog.content = item.templtContent
			this.preview_dialog.buttons = preview_buttons
			this.preview_dialog.dialog = true
		},
		previewClick(item) {
			let preview_buttons = item.button ? JSON.parse(item.button) : []
			if (preview_buttons) {
				if (preview_buttons.button) {
					preview_buttons = preview_buttons.button
				}
			} else {
				preview_buttons = []
			}

			preview_buttons.forEach(el => {
				el['text'] = el.name
			})

			this.preview_dialog.title = item.tplCodeStr
			this.preview_dialog.content = item.message
			this.preview_dialog.buttons = preview_buttons
			this.preview_dialog.dialog = true
		},
		validation_chceck() {
			this.sweetDialog.open = true
		},

		get_talks() {
			// 알림톡 가져오기
			this.edit_dialog.dialog = true
		},
	},
}
</script>
<style lang="scss" scoped>
.wrapper {
	margin: 0px !important;
}
</style>
<style lang="scss">
.surveyChoice {
	font-size: 18px;
	font-weight: bold;
	margin-right: 10px;
}
.surveyTitle {
	font-size: 18px;
	font-weight: bold;
	margin-top: 20px;
}

.filterFlex {
	padding: 20px 20px 58px 0px;
}
.filterBox {
	background: white;
	height: 100%;
	border: 2px solid #e1e1e1;
	border-radius: 5px;
}
.filterHead {
	margin: 0px !important;
	padding: 14px;
	border-bottom: 1.5px solid #e1e1e1;
}
.filterLayout {
	padding: 14.8px;
	// border-bottom: 1.5px solid #e1e1e1;`
}
.checkboxLinebreak {
	line-break: anywhere;
}
.qaLists-dialog {
	opacity: 0;
	width: 100%;
	background-color: white !important;
}
</style>
